import { Component, Input } from '@angular/core';
import { OverviewAdminActionDataModel } from '@shared/overview/overview-admin-actions/overview-admin-action-data.model';

@Component({
  selector: 'zbp-overview-admin-actions',
  templateUrl: './overview-admin-actions.component.html',
  styleUrls: ['./overview-admin-actions.component.scss'],
  standalone: false
})
export class OverviewAdminActionsComponent {

  @Input() actions: Array<OverviewAdminActionDataModel> = [];

  clickAction(action: OverviewAdminActionDataModel): void {
    if (action && action.onClick) {
      action.onClick();
    }
  }

}
